import Handlebars from "handlebars";
var str= `{{contact.url}}/deal-room/{{share.id}}`

const templateString=`<div style="border: 0px none; background-color: #ffffff; display: inline-block;">
  <a href="{{defaultValue @root.contact.url 'contact.url'}}/deal-room/{{share.id}}"  
    data-widget-placeholder=\"${str} \"
    style="border: 10px solid {{defaultValue theme.primaryColor '#E51058'}}; 
    background-color: {{defaultValue theme.primaryColor '#E51058'}}; 
    font-family: {{defaultValue theme.brandFont "'Montserrat', Helvetica, Arial, sans-serif"}}; 
    color: {{defaultValue theme.buttonTextColor '#ffffff'}};
    padding: 0px; 
    display: inline-block;
    text-decoration: none;">View Content</a>
</div>`

const template = Handlebars.compile(templateString);

export default template;